export default "__VITE_ASSET__C7JLYbP3__"